import { render, staticRenderFns } from "./radio-with-text.vue?vue&type=template&id=da1ea04e&scoped=true"
import script from "./radio-with-text.vue?vue&type=script&lang=js"
export * from "./radio-with-text.vue?vue&type=script&lang=js"
import style0 from "./radio-with-text.vue?vue&type=style&index=0&id=da1ea04e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1ea04e",
  null
  
)

export default component.exports